/**
 * @file      Curry.Internal.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */

export const CurriedArgument: unique symbol = Symbol("__CurriedArgument__");
